// URL HELPER FOR Associated Document
export const URL_GET_ASSOCIATED_DOCUMENT_LIST = '/associated_document/query';
export const URL_ADD_ASSOCIATED_DOCUMENT = '/associated_document';
export const URL_GET_ASSOCIATED_DOCUMENT = '/associated_document';
export const URL_UPDATE_ASSOCIATED_DOCUMENT = '/associated_document';
export const URL_DELETE_ASSOCIATED_DOCUMENT = '/associated_document';
export const URL_DOWNLOAD_ASSOCIATED_DOCUMENT = '/associated_document/download';
